var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{class:{
            'required-field': _vm.field.isRequired,
        },attrs:{"label-for":`id_${_vm.field._id}`}},[_c('label',{class:{
                'urdu-label': _vm.urduLabel,
            }},[_vm._v(_vm._s(_vm.field.label))]),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({
                required: _vm.field.isRequired,
                max: 24,
                min: 24,
            }),expression:"{\n                required: field.isRequired,\n                max: 24,\n                min: 24,\n            }"}],staticClass:"form-control",class:{
                    'is-invalid': _vm.errors.has(_vm.field.label),
                },attrs:{"mask":"AA ## AAAA XXXXXXXXXXXXXXXX","data-vv-name":_vm.field.label,"placeholder":"Enter Account Number/IBAN (e.g. PK 00 AAAA 000000AA234567AA)","tokens":_vm.tokens},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }